import React from 'react'
import './RegLoading.css'

function RegLoading() {
  return (
    <div className="loader" style={{background: '#44b6e7'}}></div>
  )
}

export default RegLoading